import * as actionTypes from '../actions/allActionList';

const initialState = {
  io: null,
  connectionError: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUCCESSFUL_CONNECT_TO_LIVESTREAM:
      return {
        ...state,
        io: action.io,
        connectionError: false,
      };
    case actionTypes.FAILED_TO_CONNECT_ON_LIVESTREAM:
      return {
        ...state,
        connectionError: true,
      };
    default:
      return state;
  }
};

export default reducer;
